/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featurestitle1Inputs */

const id_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur`)
};

const ms_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciri-ciri`)
};

const da_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner`)
};

const de_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen`)
};

const en_us2_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const es_es2_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

const es_mx2_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

const fil_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tampok`)
};

const fr_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités`)
};

const it_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità`)
};

const hu_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkciók`)
};

const nl_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functies`)
};

const no_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funksjoner`)
};

const pl_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

const pt_br2_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características`)
};

const pt_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades`)
};

const ro_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteristici`)
};

const fi_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuudet`)
};

const sv_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner`)
};

const vi_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng`)
};

const tr_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellikler`)
};

const cs_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkce`)
};

const bg_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функции`)
};

const ru_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возможности`)
};

const uk_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можливості`)
};

const ar_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الميزات`)
};

const hi_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताएँ`)
};

const th_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟีเจอร์`)
};

const ja_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`機能`)
};

const zh_cn2_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能特点`)
};

const zh_hant1_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能特點`)
};

const ko_about_featurestitle1 = /** @type {(inputs: About_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기능`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {About_Featurestitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_featurestitle1 = /** @type {((inputs?: About_Featurestitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featurestitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_featurestitle1(inputs)
	if (locale === "ms") return ms_about_featurestitle1(inputs)
	if (locale === "da") return da_about_featurestitle1(inputs)
	if (locale === "de") return de_about_featurestitle1(inputs)
	if (locale === "en-US") return en_us2_about_featurestitle1(inputs)
	if (locale === "es-ES") return es_es2_about_featurestitle1(inputs)
	if (locale === "es-MX") return es_mx2_about_featurestitle1(inputs)
	if (locale === "fil") return fil_about_featurestitle1(inputs)
	if (locale === "fr") return fr_about_featurestitle1(inputs)
	if (locale === "it") return it_about_featurestitle1(inputs)
	if (locale === "hu") return hu_about_featurestitle1(inputs)
	if (locale === "nl") return nl_about_featurestitle1(inputs)
	if (locale === "no") return no_about_featurestitle1(inputs)
	if (locale === "pl") return pl_about_featurestitle1(inputs)
	if (locale === "pt-BR") return pt_br2_about_featurestitle1(inputs)
	if (locale === "pt") return pt_about_featurestitle1(inputs)
	if (locale === "ro") return ro_about_featurestitle1(inputs)
	if (locale === "fi") return fi_about_featurestitle1(inputs)
	if (locale === "sv") return sv_about_featurestitle1(inputs)
	if (locale === "vi") return vi_about_featurestitle1(inputs)
	if (locale === "tr") return tr_about_featurestitle1(inputs)
	if (locale === "cs") return cs_about_featurestitle1(inputs)
	if (locale === "bg") return bg_about_featurestitle1(inputs)
	if (locale === "ru") return ru_about_featurestitle1(inputs)
	if (locale === "uk") return uk_about_featurestitle1(inputs)
	if (locale === "ar") return ar_about_featurestitle1(inputs)
	if (locale === "hi") return hi_about_featurestitle1(inputs)
	if (locale === "th") return th_about_featurestitle1(inputs)
	if (locale === "ja") return ja_about_featurestitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_featurestitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_featurestitle1(inputs)
	return ko_about_featurestitle1(inputs)
});
export { about_featurestitle1 as "about.featuresTitle" }